export enum OrderDetailTableProps {
  ColorCodeAndDescription = 'colorCodeAndDescription',
  ConfirmedDeliveryDate = 'confirmedDeliveryDate',
  ConfirmedQuantity = 'confirmedQuantity',
  DeliveredQuantity = 'deliveredQuantity',
  DeliveryNumber = 'deliveryNumber',
  Discount = 'discount',
  DiscountPercentage = 'discountPercentage',
  InvoiceNumber = 'invoiceNumber',
  Markup = 'markup',
  PriceGross = 'priceGross',
  PriceNet = 'priceNet',
  PriceNetConfirmed = 'priceNetConfirmed',
  PriceRrp = 'priceRrp',
  Quantity = 'quantity',
  RequestedDeliveryDate = 'requestedDeliveryDate',
  RequestedQuantity = 'requestedQuantity',
  ShippingDate = 'shippingDate',
  ShippingDeliveryDate = 'shippingDeliveryDate',
  Sizes = 'sizes',
  Style = 'style',
  StyleId = 'rootId',
  StyleTitle = 'rootTitle',
  TrackingNumber = 'trackingNumber',
  Type = 'type',
  UnconfirmedQuantity = 'unconfirmedQuantity',
  UnitDiscount = 'unitDiscount',
  UnitPriceGross = 'unitPriceGross',
  UnitPriceNet = 'unitPriceNet',
  UnitPriceRrp = 'unitPriceRrp',
  Variants = 'variants',
}
